'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdPhotoSizeSelectLarge = function MdPhotoSizeSelectLarge(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm5 31.6h16.6l-5.3-7.1-4.1 5.4-3.1-3.6z m-3.4-13.2h23.4v16.6h-20q-1.3 0-2.3-1t-1.1-2.4v-13.2z m6.8-13.4h3.2v3.4h-3.2v-3.4z m6.6 0h3.4v3.4h-3.4v-3.4z m-10 0v3.4h-3.4q0-1.3 1.1-2.3t2.3-1.1z m23.4 26.6h3.2v3.4h-3.2v-3.4z m0-26.6h3.2v3.4h-3.2v-3.4z m-26.8 6.6h3.4v3.4h-3.4v-3.4z m33.4-6.6q1.3 0 2.3 1.1t1.1 2.3h-3.4v-3.4z m0 6.6h3.4v3.4h-3.4v-3.4z m-13.4-6.6h3.4v3.4h-3.4v-3.4z m16.8 26.6q0 1.3-1.1 2.3t-2.3 1.1v-3.4h3.4z m-3.4-13.2h3.4v3.2h-3.4v-3.2z m0 6.6h3.4v3.4h-3.4v-3.4z' })
        )
    );
};

exports.default = MdPhotoSizeSelectLarge;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/photo-size-select-large.js
// module id = 1332
// module chunks = 36573943044255 79611799117203 213534597649335